module.exports = __webpack_public_path__ + "img/autos.95977e8e.jpg";